<template>
	<div id="reservation">
	    <div class="page-container" id="reservation-container">
	        <div class="page-content" id="reservation-content">
				<header id="main-menu" class="logo-header">
				    <div class="store-info menu-content">
				        <div class="logo-col">
				            <!--<img src="https://pic.streetaway.cn/uploads/4b/29/d4/48/07/fc19e24c99a90ae85c61d8.png">-->
				            <img :src="storeLogo" v-if='storeLogo!="" || storeLogo!=undefined'>

				        </div>
				        <div class="store-name">
				            <h1>{{storeName}}</h1>
				        </div>
				    </div>
				</header>
	            <div id="main-container">
	                <div class="errorModule">
	                    <div class="errorTitle">
	                        <h1>OOPS!</h1>
	                        <h3>Something is wrong</h3>
	                    </div>
	                    <div class="errorContent">
	                    		<p>{{ errorWords }}</p>
	                    </div>
                        <div class="backSelectCol">
                            <h4>You can go back to </h4>
                        </div>
                        <div class="errorBackLink">
                            <a :href="url_link" id="backSelectDate">Make a new reservation</a>
                        </div>

	                </div>
	            </div>
	        </div>
	    </div>

	</div>

</template>
<script>
import $ from 'jquery';
import moment from 'moment';
import axios from 'axios';
import Loading from '../components/loading.vue';
export default {
  name: 'Error',
  components: {
  	Loading,
  },

  data() {
	return {
		storeLogo:'',
		url_link:'/reservation/StreetAwayDemo',
        storeName:'Error Link',
        storePhone:'10000',
        errorWords:'提示什么写在这里',
        isHidden:true,
		paramsValid: true,
		currentPage: 0,
		week: 'Wednesday',
		currentSize: '5',
		currentDate: '10 Jun 2020',
		currentTime: '08:30',
		infoForm: {
			firstName: 'Eric',
			surname: 'Guo',
			areaCode:'+44',
			phone: '12345678901',
			email: 'BBBddd@AAa.org',
		},
		deposit:"$44.00",
		read: true,
	    selectedDate:'',
	    store_id :0,
	    showCancelAlert:false,
	    cancelConfirmed:false,
	    res_id:0,
	    loadingShow:false
	}


  },
  computed: {


  },
  created() {
    var reserve_number=this.$route.params.reserve_number;
    this.res_id=reserve_number;
    this.getReserveData(reserve_number);
  },

  methods: {
        getStoreData(store_id){
          axios.get(process.env.API_URL+'htmlReserve/getStoreData',{params:{store_id:store_id}}).then(res=>{
            console.log(res);
            this.store_id=res.data.data.store_id;
            this.storeName =res.data.data.store_name;
            this.storePhone=res.data.data.contact_phone;
            this.storeLogo = res.data.data.logo;
          })
        },
    getReserveData(res_id){
      axios.get(process.env.API_URL+'htmlReserve/getReserveData',{params:{reserve_id:res_id}}).then(res=>{
        if(res.data.data.status==4){
            this.cancelConfirmed=true;
            this.isHidden = false ;
        }
        this.getStoreData(res.data.data.store_id);
        this.infoForm.firstName=res.data.data.cust_first_name;
        this.infoForm.surname=res.data.data.cust_surname;
        this.currentDate=res.data.data.date;
        this.week=res.data.data.wekday;
        this.currentTime=res.data.data.r_time;
        this.currentSize=res.data.data.covers;
        this.infoForm.phone=res.data.data.cust_phone;
        this.infoForm.email=res.data.data.cust_email;
        if(res.data.data.slogo !=1){
          this.storeLogo=res.data.data.slogo;
        }
        this.loadingShow=false;
      })
    },
    confirmReserve(res_id){
      axios.post(process.env.API_URL+'htmlReserve/confirmReserve',{params:{res_id:res_id}}).then(res=>{
      this.isHidden=false;
      })
    },
    cancelConfirm(res_id){
      axios.post(process.env.API_URL+'htmlReserve/cancelConfirm',{params:{res_id:res_id}}).then(res=>{
        this.cancelConfirmed=true;
      })
    }


  },
  mounted() {
  }
}

</script>
<style scoped="scoped">
#reservation .errorBackLink{ margin-top: 30px;}
@media screen and (min-width: 640px) {
#reservation #main-container{ box-shadow: 5px 0 15px rgba(0,0,0,.2), -5px 0 15px rgba(0,0,0,.2); }
#reservation .errorModule a{ font-size: 16px; padding: 10px 20px;}
#reservation .errorContent{ font-size: 20px; padding: 5px 20px;}
   }
</style>



// WEBPACK FOOTER //
// src/page/Error.vue